import { Component, OnInit } from '@angular/core'
import {
  ActivatedRoute,
  NavigationEnd,
  ParamMap,
  Router,
  RouterLink,
} from '@angular/router'
import { Apollo, gql } from 'apollo-angular'
import { Subscription } from 'rxjs'

interface Logo {
  alt: string
  height: number
  width: number
  title: string
  url: string
}

interface Page {
  title: string
  link: [string]
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  logo?: Logo
  language?: string
  contact?: string
  pages: Page[]

  private dataSub?: Subscription

  constructor(private apollo: Apollo, private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe((ev) => {
      if (!(ev instanceof NavigationEnd)) return

      const { url } = ev

      if (url.startsWith('/en')) this.language = '/en'
      else if (url.startsWith('/fi')) this.language = '/fi'
      else this.language = '/'

      this.data(this.language.substr(1) || 'sv')
    })
  }

  private data(lang = 'sv'): void {
    this.dataSub?.unsubscribe()

    this.dataSub = this.apollo
      .watchQuery({
        query: gql`
          {
            global {
              logo {
                url
                height
                width
                alt
                title
              }
              contactInfo(markdown: true)
            }
            allPages {
              title(locale: ${lang})
              slug(locale: ${lang})
            }
          }
        `,
      })
      .valueChanges.subscribe((result: any) => {
        const { data } = result
        const { global, allPages } = data

        if (!global || !allPages) return

        this.logo = global.logo as Logo
        this.contact = global.contactInfo

        this.pages = allPages.map((p) => {
          return {
            title: p.title,
            link: [`${lang}/${p.slug}`],
          }
        })
      })
  }
}
